var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.currentProps)?_c(_setup.currentProps.to ? _setup.AbLink : 'button',{tag:"component",staticClass:"ab-button",class:[
    {
      'ab-button_full': _setup.currentProps.block,
      'ab-button_disabled': _setup.currentProps.disabled,
      'ab-button_inverted': _setup.currentProps.inverted,
      'ab-button_multilayered': _setup.currentProps.multilayered,
    },
    _setup.currentVariant,
    `ab-button_${_setup.currentProps.size}`,
  ],attrs:{"type":_setup.currentProps.type,"to":_setup.currentProps.to,"disabled":_setup.currentProps.disabled,"target":_setup.currentProps.target},on:{"click":_setup.clickEvent}},[(_setup.currentProps.effect === 'glow')?_c(_setup.AbButtonEffectGlow,{staticClass:"ab-button__glow"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ab-button__inner",class:{
      'ab-button__inner_h-fit': _setup.currentProps.fitHeight,
    },style:({ minWidth: _setup.currentProps.minWidth })},[_vm._t("default"),_vm._v(" "),(_setup.currentProps.icon)?_c(_setup.AbIcon,{staticClass:"ab-button__icon",attrs:{"icon":_setup.currentProps.icon}}):_vm._e()],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }